import React from 'react';
import { StyleSheet, View } from 'react-native';
import { HelpNavigationButton, NavigationTextButton } from './TextButton';
import { rem } from './values';
import { isWeb } from '../constants';
export const NavigationHeaderRightTextButton = React.memo(({ text, onPress }) => (<View style={styles.container}>
    <NavigationTextButton text={text} onPress={onPress}/>
  </View>));
export const NavigationHeaderRightHelpButton = React.memo(({ onPress }) => (<View style={styles.container}>
    <HelpNavigationButton onPress={onPress} black/>
  </View>));
const styles = StyleSheet.create({
    container: {
        ...(isWeb && { paddingRight: rem(16) }),
    },
});
